import React, { Component } from 'react';

class HowitworksExtended extends Component {
  render() {
    const { data, showImage = false } = this.props;
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <section className="p-80px-tb gray-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <div className="section-title text-center m-50px-b">
                <h2>{data.pageTitle || '導入の流れ'}</h2>
                {data.pageSubtitle && <p className="lead text-muted">{data.pageSubtitle}</p>}
              </div>
            </div>
          </div>

          {/* Process Steps */}
          <div className="row align-items-center">
            {data.steps && data.steps.map((step, i) => {
              return (
                <div key={i} className="col-lg-4 col-md-6 m-20px-b">
                  <div className="how-it-box text-center p-30px-lr p-50px-tb m-10px-t m-10px-b h-100">
                    <div className="step-number bg-primary text-white rounded-circle m-auto m-20px-b"
                         style={{width: '60px', height: '60px', lineHeight: '60px'}}>
                      <h3 className="text-white m-0">{i + 1}</h3>
                    </div>
                    <i className={`${step.icon} icofont-3x text-primary m-20px-b`}></i>
                    <h4 className="m-20px-b">{step.title}</h4>
                    <p className="text-muted">{step.content}</p>
                    {step.duration && (
                      <p className="text-primary font-weight-bold m-10px-t">{step.duration}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Timeline Section */}
          {data.timeline && (
            <div className="row m-50px-t">
              <div className="col-md-12">
                <h3 className="text-center m-30px-b">{data.timelineTitle}</h3>
                <div className="timeline-container">
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>フェーズ</th>
                        <th>期間</th>
                        <th>主な活動</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.timeline.map((item, i) => (
                        <tr key={i}>
                          <td className="font-weight-bold">{item.phase}</td>
                          <td>{item.duration}</td>
                          <td>{item.activities}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default HowitworksExtended;